import { createFileRoute } from '@tanstack/react-router'

import { timeZonesSearchSchema } from '@/components/TimeZones/search'
import { TimeZonesPage } from '@/components/TimeZones/TimeZonesPage'

/** Wiring only. The schema lives beside the page. */
export const Route = createFileRoute('/_app/time-zones/')({
  validateSearch: timeZonesSearchSchema,
  component: TimeZonesRoute,
})

function TimeZonesRoute() {
  return <TimeZonesPage search={Route.useSearch()} />
}
